import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { ThemeContextProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import Login from './components/Auth/Login';
import Dashboard from './components/Dashboard/Dashboard';
import Buildings from './components/Buildings/Buildings';
import Flats from './components/Flats/Flats';
import WorkOrders from './components/WorkOrders/WorkOrders';
import OutOfSiteTasks from './components/OutOfSiteTasks/OutOfSiteTasks';
import WorkOrderDetail from './components/WorkOrders/WorkOrderDetail';
import Expenses from './components/Expenses/Expenses';
import Inventory from './components/Inventory/Inventory';
import Technicians from './components/Technicians/Technicians';
import Users from './components/Users/Users';
import Roles from './components/Roles/Roles';
import Settings from './components/Settings/Settings';
import Reports from './components/Reports/Reports';
import Attendance from './components/Attendance/Attendance';
import QuickCheckInDetail from './components/QuickCheckInDetail/QuickCheckInDetail';
import OutOfSiteTaskDetail from './components/OutOfSiteTaskDetail/OutOfSiteTaskDetail';
import Layout from './components/Layout/Layout';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return <div>Loading...</div>;
  }
  
  return user ? <>{children}</> : <Navigate to="/login" />;
};

function App() {
  return (
    <ThemeContextProvider>
      <AuthProvider>
        <LanguageProvider>
          <NotificationProvider>
            <Router>
              <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={
                <ProtectedRoute>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/buildings" element={
                <ProtectedRoute>
                  <Layout>
                    <Buildings />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/flats" element={
                <ProtectedRoute>
                  <Layout>
                    <Flats />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/work-orders" element={
                <ProtectedRoute>
                  <Layout>
                    <WorkOrders />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/out-of-site-tasks" element={
                <ProtectedRoute>
                  <Layout>
                    <OutOfSiteTasks />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/work-orders/:id" element={
                <ProtectedRoute>
                  <Layout>
                    <WorkOrderDetail />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/users" element={
                <ProtectedRoute>
                  <Layout>
                    <Users />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/roles" element={
                <ProtectedRoute>
                  <Layout>
                    <Roles />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/technicians" element={
                <ProtectedRoute>
                  <Layout>
                    <Technicians />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/expenses" element={
                <ProtectedRoute>
                  <Layout>
                    <Expenses />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/inventory" element={
                <ProtectedRoute>
                  <Layout>
                    <Inventory />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/settings" element={
                <ProtectedRoute>
                  <Layout>
                    <Settings />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/reports" element={
                <ProtectedRoute>
                  <Layout>
                    <Reports />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/quick-check-ins/:id" element={
                <ProtectedRoute>
                  <Layout>
                    <QuickCheckInDetail />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/out-of-site-tasks/:id" element={
                <ProtectedRoute>
                  <Layout>
                    <OutOfSiteTaskDetail />
                  </Layout>
                </ProtectedRoute>
              } />
              <Route path="/attendance" element={
                <ProtectedRoute>
                  <Layout>
                    <Attendance />
                  </Layout>
                </ProtectedRoute>
              } />
                <Route path="*" element={<Navigate to="/" />} />
              </Routes>
            </Router>
          </NotificationProvider>
        </LanguageProvider>
      </AuthProvider>
    </ThemeContextProvider>
  );
}

export default App;
